module.exports = __webpack_public_path__ + "static/media/mobexlogo.380d1d2d.svg";